import React from 'react';
import { Descriptions, Space, Skeleton } from 'antd';
import SectionTitle from '../../../components/SectionTitle';
import moment from 'moment';

const AnalystProcessFsFormPreview = ({ formData, loading }) => {
    const data = formData || {};
    const DateFormat = 'MM-DD-YYYY';

    return (
        <Space className='analyst-process-fs-form-preview' direction="vertical" size="large" style={{ width: '100%' }}>
            <SectionTitle level={3}>Claim Information</SectionTitle>
            <Skeleton active loading={loading} title={false} paragraph={{ rows: 3 }}>
                <Descriptions bordered>
                    <Descriptions.Item label="Inspection Date">{data.inspectionDate ? moment(data.inspectionDate).format(DateFormat) : 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Job Name">{data.jobName || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="FS Manager">{data.fsManager || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Invoice Date" >
                        {data.invoiceDate ? moment(data.invoiceDate).format(DateFormat) : 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Claim Number" span={3}>{data.claimNumber || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Claim Date">
                        {data.claimDate ? moment(data.claimDate).format(DateFormat) : 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Installation Date"  span={3}>
                        {data.installationDate ? moment(data.installationDate).format(DateFormat) : 'N/A'}
                    </Descriptions.Item>
                </Descriptions>
            </Skeleton>
            <SectionTitle level={3}>Contact Information</SectionTitle>
            <Skeleton active loading={loading} title={false} paragraph={{ rows: 4 }}>
                <Descriptions bordered column={2}>
                    <Descriptions.Item label="Contact Name">{data.contactName || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Email Address">{data.emailAddress || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Contact Phone Number">{data.contactPhoneNumber || 'N/A'}</Descriptions.Item>
                    
                      <Descriptions.Item label="Contact Type">
                        {Array.isArray(data.contactType) && data.contactType.length > 0
                        ? data.contactType.join(', ')
                        : 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Claim Reason">{data.claimReason || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Account Exec">{data.accountExec || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="AE Phone #">{data.aePhone || 'N/A'}</Descriptions.Item>
                </Descriptions>
            </Skeleton>
            <SectionTitle level={3}>Job Site Information</SectionTitle>
            <Skeleton active loading={loading} title={false} paragraph={{ rows: 4 }}>
                <Descriptions bordered column={2}>
                    <Descriptions.Item label="Job Site Address">{data.jobSiteAddress || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Job Site City">{data.jobSiteCity || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Job Site State">{data.jobSiteState || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Job Site Zip Code">{data.jobSiteZip || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="RVP">
                        {Array.isArray(data.siteInstallRelated) && data.siteInstallRelated.length > 0
                        ? data.siteInstallRelated.join(', ')
                        : 'N/A'}
                    </Descriptions.Item>
                </Descriptions>
            </Skeleton>
            <SectionTitle level={3}>Product Information</SectionTitle>
            <Skeleton active loading={loading} title={false} paragraph={{ rows: 4 }}>
                <Descriptions bordered column={2}>
                    <Descriptions.Item label="Order Number">{data.orderNumber || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Invoice">{data.orderInvoice || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Style">{data.style || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Color">{data.color || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Backing">{data.backing || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Job Number">{data.jobNumber || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Sq. Ft or Yards">{data.sqFt || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Underlayment">{data.underlayment || 'N/A'}</Descriptions.Item>
                </Descriptions>
            </Skeleton>
            <SectionTitle level={3}>Warranty Information</SectionTitle>
            <Skeleton active loading={loading} title={false} paragraph={{ rows: 4 }}>
                <Descriptions bordered column={1}>
                    <Descriptions.Item label="Warranty Information">{data.mforceManufacturing || 'N/A'}</Descriptions.Item>
                </Descriptions>
            </Skeleton>
            <SectionTitle level={3}>Inspector Notes</SectionTitle>
            <Skeleton active loading={loading} title={false} paragraph={{ rows: 4 }}>
                <Descriptions bordered column={2}>
                    <Descriptions.Item label="Inspector to complete">{data.inspectorComplete || 'N/A'}</Descriptions.Item>
                </Descriptions>
            </Skeleton>
            <SectionTitle level={3}>Installation Details</SectionTitle>
            <Skeleton active loading={loading} title={false} paragraph={{ rows: 4 }}>
                <Descriptions bordered column={2}>
                    <Descriptions.Item label="Type Install">
                        {Array.isArray(data.typeInstall) && data.typeInstall.length > 0
                        ? data.typeInstall.join(', ')
                        : 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Type Grade">
                        {Array.isArray(data.typeGrade) && data.typeGrade.length > 0
                        ? data.typeGrade.join(', ')
                        : 'N/A'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Areas Affected">{data.areasAffected || 'N/A'}</Descriptions.Item>
                    <Descriptions.Item label="Adhesive(s) Used">{data.adhesiveUsed || 'N/A'}</Descriptions.Item>
                </Descriptions>
            </Skeleton>
            <SectionTitle level={3}>Site Inspection Observations</SectionTitle>
            <Skeleton active loading={loading} title={false} paragraph={{ rows: 4 }}>
                <Descriptions bordered column={2}>
                    <Descriptions.Item label="(To be completed by Field Service Manager or Inspector)">{data.analystNotes || 'N/A'}</Descriptions.Item>
                </Descriptions>
            </Skeleton>
        </Space>
    );
};

export default AnalystProcessFsFormPreview;